import React from 'react'
import { Card, CardContent, Container, Typography } from '@material-ui/core'
import Page from '../Page'
import FormUser from './shared/form'
import { FORM_ACTIONS } from 'src/utils/constants/general'
import ErrorsValidation from '../shared/displayErrorsValidations'
import PageContainer from 'src/containers/shared/PageContainer';

const AddUser = (props) => {
  const {
    roles,
    errors,
    loading,
    addUser,
  } = props;

  return (
    <PageContainer title="Agregar Usuario" maxWidth={false}>
        <Typography
          color="textPrimary"
          variant="h2"
          className="mb-3"
        >
          Agregando Usuario
        </Typography>
        <ErrorsValidation errors={errors} />
        <Card>
          <CardContent>
            <FormUser 
              action={FORM_ACTIONS.ADD}
              roles={roles}
              addUser={addUser}
              loading={loading}
            />
          </CardContent>
        </Card>
    </PageContainer>
  )
}

export default AddUser
